import { useTranslations } from 'next-intl';
import { useLazySendAdAuctionAutoBidQuery } from '@/src/api/api';
import AuctionBidControllerTemplate from './AuctionBidControllerTemplate';

export default function AuctionAutoBidController({
  minimalBid,
  increment,
  customerAutoBid = 0,
  auctionId,
  auctionEnd,
  ad,
  autofill = true,
  onSuccess,
}: {
  minimalBid: number;
  increment: number;
  customerAutoBid?: number;
  auctionId: number;
  auctionEnd: number;
  ad: any;
  autofill?: boolean;
  onSuccess?: (a?: any) => void;
}) {
  const t = useTranslations('AuctionAutoBidController');

  return (
    <AuctionBidControllerTemplate
      useBidQuery={useLazySendAdAuctionAutoBidQuery}
      auctionId={auctionId}
      auctionEnd={auctionEnd}
      minimalBid={minimalBid}
      increment={increment}
      customerAutoBid={customerAutoBid}
      inputName='amount_max'
      label={t('placeAutoBid')}
      sublabel={t('placeAmount')}
      confirmLabel={t('confirmBid')}
      ad={ad}
      autofill={autofill}
      onSuccess={onSuccess}
    />
  );
}
